import { render } from "./compress.vue?vue&type=template&id=e892b5b2"
import script from "./compress.vue?vue&type=script&lang=js"
export * from "./compress.vue?vue&type=script&lang=js"

import exportComponent from "/home/minify-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__